/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import GeoLandings from 'subsys/geo-landings';
import { dictConnect } from 'api/data-dict';
import Row, { Col } from 'components/row';
import Link from 'components/link';

import { checkIsRegionFounded } from '../../page-home/blocks/help-block';

import translates from './block-text-link-i18n.json';

import 'styles/bild/blocks/blockTextLink/_block-text-link.scss';

const bemClasses = new Bem('blockTextLink');

export default class BlockTextLink extends Component {
  render() {
    return (
      <GeoLandings base={{}}>
        <GeoTextLink {...this.props} />
      </GeoLandings>
    );
  }
}

@dictConnect({
  url: 'location/region-promotional-links',
  injectPropName: 'regionPromotionalLinks',
})
@I18nHoc(translates)
class GeoTextLink extends Component {
  static propTypes = {
    className: PropTypes.string,
    textMain: PropTypes.string,
    linkProps: PropTypes.shape({}),
    linkText: PropTypes.string,
    geolocation: PropTypes.shape({}),
    regionPromotionalLinks: PropTypes.array, // eslint-disable-line
    complexTree: PropTypes.string,
    dataGtmItemPlace: PropTypes.string
  };

  static defaultProps = {
    linkProps: {
      // noRedirector: true,
      external: true,
      blank: true
    }
  };

  render() {
    const { i18n } = this;
    const {
      className, linkProps, dataGtmItemPlace,
      geolocation = {}, complexTree, regionPromotionalLinks
    } = this.props;
    const textMain = get(this, 'props.textMain') || i18n('textMain');
    const linkText = get(this, 'props.linkText') || i18n('linkText');
    const selectedAgency = checkIsRegionFounded(geolocation, complexTree, regionPromotionalLinks);

    if (!textMain || !linkProps || !linkText || !selectedAgency) return null;

    const url = get(selectedAgency, 'url');

    return (
      <div {...bemClasses({ extra: className })}>
        <span {...bemClasses('img', 'substrate imgShapeLink')} />
        <span {...bemClasses('img', 'substrate imgShapeLinkBig')} />
        <span {...bemClasses('img', 'substrate imgShapeBig')} />
        <Row {...bemClasses('row')} alignIcenter>
          <Col {...bemClasses('col')} allPr={0}>
            <div {...bemClasses('topic')}><div {...bemClasses('text')}><h3 children={textMain} /></div></div>
          </Col>
          <Col {...bemClasses('col')} allAuto allPr={0}>
            <div>
              <Link
                {...bemClasses('link')}
                title={i18n('linkTitle')}
                {...linkProps}
                dataProps={dataGtmItemPlace ? { 'data-gtm-item': `learn-more-${dataGtmItemPlace}` } : null}
                href={url}
              >
                <span {...bemClasses('linkContent')}>
                  <span {...bemClasses('linkShadow')} />
                  <span {...bemClasses('text')} children={linkText} />
                </span>
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
